import {
  call, put, select,
} from 'redux-saga/effects';
import FrontSonda from '@bit/gerenciatd.utils.front-sonda';
import { getConstantsInfoEmp } from '@bit/gerenciatd.adabyron-cloud.miscellaneous';
import { actions } from '../reducers/common';
import { normalizeConstants } from './normalizers/common';

const contextStore = state => state.context.data;

export function* getBusinessProps() {
  const context = yield select(contextStore);
  try {
    const response = yield call(getConstantsInfoEmp, context);
    const responseNormalized = normalizeConstants(response.response);
    yield put(actions.setBusinessConstants(responseNormalized));
  } catch (error) {
    const sonda = new FrontSonda({
      processName: 'getBusinessProps',
      context,
      filePath: 'sagas/common',
    });
    sonda.errorMessage({ error });
  }
}
